import { Svg, SvgProps } from 'react-native-svg'
import { Rect } from 'react-native-svg'

export default function DvFlag(props: SvgProps) {
  return (
    <Svg width="60" height="40" viewBox="0 0 60 40" fill="none" {...props}>
      <Rect width="60" height="40" fill="#FFAA00" />
    </Svg>
  )
}
